import { createFileRoute } from '@tanstack/react-router'
import { ReportGenerationPage } from 'pages/reporting/ReportGenerationPage'
import { ReportRedirectPage } from 'pages/reporting/ReportRedirectPage'
import { ReportTemplateId } from 'pages/reporting/shared/reportTemplates'

interface ReportSearchParams {
  templateId?: ReportTemplateId
  metadataEntryId?: string
}

/**
 * Route component that renders either:
 * - ReportRedirectPage: when no templateId is in the URL (fetches metadata and redirects)
 * - ReportGenerationPage: when templateId is present (renders the report with the given template)
 */
const ReportRouteComponent = () => {
  const { templateId } = Route.useSearch()

  if (!templateId) {
    return <ReportRedirectPage />
  }

  return <ReportGenerationPage templateId={templateId} />
}

export const Route = createFileRoute('/reporting/$siteID/$reportID')({
  component: ReportRouteComponent,
  staticData: {
    title: 'Report',
    layout: {
      enableScrolling: true,
    },
  },
  validateSearch: (search: Record<string, unknown>): ReportSearchParams => {
    return {
      templateId: search.templateId as ReportTemplateId | undefined,
      metadataEntryId: search.metadataEntryId as string | undefined,
    }
  },
})
